import { LoadSpinner } from '@calizahq/react-components-v2'
import React, { useMemo } from 'react'

import { NoResults, Table } from '@/components'
import ListFilter, { FilterTypes } from '@/components/ListFilter/ListFilter'
import { useMobile } from '@/hooks'
import useReservations from '@/hooks/useReservations/useReservations'

import { MobileReservationCard } from './MobileReservationCard'
import { reservationListMapper, ReservationsListColumns } from './Reservations.data'

export function Reservations() {
  const { isMobile } = useMobile()
  const reservationsQuery = useReservations()
  const reservations = reservationsQuery.data

  const data = useMemo(() => {
    return reservations?.reservations ? reservationListMapper(reservations?.reservations) : []
  }, [reservations])

  const columns = useMemo(() => {
    return ReservationsListColumns
  }, [])

  return (
    <div className="flex w-full flex-col p-4 md:p-8">
      <ListFilter
        hideLengthOfStayFilter={false}
        hideReservationMoveInFilter={true}
        hideReservationMoveOutFilter={false}
        hideSearch={false}
        listType={FilterTypes.RESERVATIONS}
        title="Reservations"
      />
      {reservationsQuery?.isLoading ? (
        <div className="flex h-20 w-full items-center justify-center">
          <LoadSpinner className="icon-secondary" isCurrentColor={true} size={2} />
        </div>
      ) : (
        <>
          {isMobile ? (
            <>
              {(reservations &&
                reservations?.reservations?.map((res, index) => (
                  <MobileReservationCard header={res.member?.fullName || ' '} key={index} reservation={res} />
                ))) || <NoResults />}
            </>
          ) : (
            <Table className={''} columns={columns as any} data={data} />
          )}
        </>
      )}
    </div>
  )
}
